<template lang="html">
  <div class="container" id="text-page">
    <h1 class="page-title txt-black">Preguntas Frecuentes</h1>

    <h6>1.-¿Cómo debo realizar una cotización?</h6>
    <p>
      Si necesita una refacción automotriz es necesario tener a la mano Marca, Modelo, Año, Motor, Posición de la pieza que necesita. La forma correcta de solicitar la posición de las refacciones deben solicitarse tomando en cuenta que usted esta sentado en el volante; En el caso que usted requiera una cotización de Tapete Automotriz, Hule pasillo, Neopreno y/o Empaque, es necesario que nos proporcione el área a cubrir.
    </p>

    <br />
    <h6>2.-¿Cuentan con servicio a domicilio?</h6>
    <p>
      A través de plataformas de reparto hacemos llegar el producto a tu domicilio de manera exprés máximo 90 minutos.
    </p>

    <br />
    <h6>3.-¿Cómo me puedo comunicarme con ustedes?</h6>
    <p>
      Nuestras 3 líneas telefónicas son las siguientes: 01 (33) 36-46-09-45, 01 (33) 35-87-77-36 y 01 (33) 33-67-48-95.<br />
      Nuestro número de WhatsApp es: 33-17-28-38-18 y 33-17-28-31-12<br />
      Nuestro Facebook: HULES Automotrices Becerra GDL<br />
      Nuestra Página de Google +: HULES AUTOMOTRICES BECERRA<br />
      Email: contacto@hulesbecerra.com
    </p>

    <br />
    <h6>4.-¿Cuál es su horario de atención?</h6>
    <p>
      Lunes a Viernes: 9:00 am a 3:00 pm y de 4:00 pm a 6:30 pm Sábados: 9:00 am a 2:00 pm
    </p>

    <br />
    <h5>5.-¿Qué Garantía tienen los productos que comercializan?</h5>
    <p>
      Los productos a base de hule-metal tienen 3 meses de garantía en nuestra tienda, y los productos que comprenden el sistema de enfriamiento 2 meses de garantía.
    </p>

    <br />
    <h5>6.-¿Qué productos puedo encontrar con ustedes?</h5>
    <ul>
      <li>Soportes de Motor</li>
      <li>Soportes de Transmisión</li>
      <li>Cubre polvos y/o Machetas</li>
      <li>Bases de amortiguador</li>
      <li>Repuestos de Soportes</li>
      <li>Mangueras para Radiador</li>
      <li>Mangueras del Cuerpo de Aceleración</li>
      <li>Mangueras de Vació</li>
      <li>Mangueras de Gasolina</li>
      <li>Bandas Automotrices e Industriales</li>
      <li>Hules de Barra</li>
      <li>Hules de Poliuretano</li>
      <li>Hules de Escape</li>
      <li>Hules de Cremallera</li>
      <li>Hules de Muey Agregar</li>
      <li>Hules de amortiguador</li>
      <li>Calzas</li>
      <li>Casetas</li>
      <li>Hule Pela Pollos</li>
      <li>Sordinas</li>
      <li>Regatones</li>
      <li>Coples y Galletas de Dirección</li>
      <li>Codos</li>
      <li>Fuelles</li>
      <li>Hules Misceláneos</li>
      <li>Placas de quinta rueda</li>
      <li>Hules de pedal modificar (antes pedales)</li>
      <li>Depósitos de Anticongelante</li>
      <li>Radiadores eliminar</li>
      <li>Poleas de Accesorios y/o Poleas de Distribución</li>
      <li>Tensores de accesorios modificar (antes tensores)</li>
      <li>Tubos de enfriamiento modificar (antes tubo de agua)</li>
      <li>Termostatos</li>
      <li>Bombas de Agua</li>
      <li>Tomas de Agua</li>
      <li>Anticongelante</li>
      <li>Tapas de punterías Agregar</li>
      <li>Enfriadores de Aceite Agregar</li>
      <li>Cabezas de motor Agregar</li>
      <li>Actuadores tensores hidráulicos de distribución Agregar</li>
      <li>KITS de banda de districión Agregar</li>
      <li>Multiples de Admisión Agregar</li>
      <li>Empaques de Puerta</li>
      <li>Empaques de Cajuela</li>
      <li>Cañuelas</li>
      <li>Empaques planos</li>
      <li>Hule Pasillo</li>
      <li>Neopreno</li>
      <li>Nitrilo Sanitario</li>
      <li>Tapete para Caballo</li>
      <li>Anti fatigas</li>
      <li>Picos de Pájaro</li>
      <li>Topes de Rebote</li>
      <li>Loderas</li>
      <li>Topes de Estacionamiento</li>
      <li>Topes de defensa Agregar</li>
      <li>Tapetes Automotrices</li>
      <li>Limpiaparabrisas</li>
      <li>Pegamento Automotriz</li>
      <li>Abrazaderas</li>
      <li>Grapas Automotrices</li>
      <li>Autopartes</li>
      <li>Ligas O-ring modificar (antes ligas)</li>
    </ul>

    <br />
    <p>
      Y muchos productos más de estos ramos.
    </p>
  </div>
</template>

<script>
export default {
}
</script>
